"use client";

import {
	type ApiData,
	serialize,
} from "@tosize/tosize-furniture-configurator/src/components/renderer/data";
import type { CabinetState } from "@tosize/tosize-furniture-configurator/src/context/StoreContext";
import { type FC, type PropsWithChildren, useMemo, useState } from "react";
import { CabinetContext } from "~/app/[lang]/(default)/product/[id]/variant/Cabinets/Context";
import type { LangParams } from "~/app/[lang]/layout";
import type { ProductType } from "~/graphql/shared/product";

interface Props extends LangParams {
	product: NonNullable<ProductType>;
	orderData?: string;
}

export const CabinetProvider: FC<PropsWithChildren<Props>> = ({ children, ...props }) => {
	const [api, setApi] = useState<ApiData | undefined>(undefined);
	const [store, setStore] = useState<CabinetState>();
	const [openSampleDialog, setOpenSampleDialog] = useState(false);

	const orderData = useMemo(() => {
		if (props.orderData) {
			return props.orderData;
		}

		if (props.product.jsonConfiguration) {
			return props.product.jsonConfiguration;
		}

		return undefined;
	}, [props.orderData, props.product.jsonConfiguration]);

	const canvasIsCustomized = useMemo(() => {
		if (store && orderData) {
			return serialize(store) !== orderData;
		}

		return false;
	}, [orderData, store]);

	return (
		<CabinetContext.Provider
			value={{
				api,
				setApi,
				store,
				setStore,
				orderData,
				canvasIsCustomized,
				openSampleDialog,
				setOpenSampleDialog,
			}}
		>
			{children}
		</CabinetContext.Provider>
	);
};
